import styled from "styled-components";

export const LandingStyle = styled.div`
  .topline {
    height: 15px;
    background: #90ac85;
  }
`;
